module.exports = __webpack_public_path__ + "4f1b743bd0c767167e60479991afcb5e.otf";